module.exports = __webpack_public_path__ + "static/media/womans-apparel.efc1257b.jpg";